module.exports = __webpack_public_path__ + "img/sspai.8cf94ec0.png";